import { useTranslation } from "react-i18next";

/**
 * Skip navigation link for keyboard and screen reader users.
 * Allows users to bypass repetitive navigation and jump to main content.
 *
 * Usage: Place at the top of the page, before any navigation.
 * Main content should have id="main-content" for the skip link target.
 */
export function SkipLink() {
  const { t } = useTranslation();

  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:p-4 focus:bg-primary focus:text-primary-foreground focus:top-0 focus:left-0 focus:outline-none focus:ring-2 focus:ring-ring"
    >
      {t("a11y.skipToContent")}
    </a>
  );
}
